import { Button, Wrapper } from "nystem-components";

const stateList = (state, fallback) =>
  [state === undefined || state === null ? fallback : state]
    .flat()
    .filter((item) => item !== undefined && item !== null);

const stateIncludes = (states, value) => states.some((state) => `${state}` === `${value}`);

const SelectButton = ({ model, setValue, value }) => {
  const { trueState, trueOnState, falseState, btnType, falseOnState } = model;
  const trueStates = stateList(trueOnState, trueState);
  const falseStates = stateList(falseOnState, falseState);
  const isTrue = stateIncludes(trueStates, value);
  const isFalse = falseOnState === undefined || falseOnState === null ? !isTrue : stateIncludes(falseStates, value);

  const handleChange = () => setValue(isTrue ? falseState : trueState);

  let text = "";
  let type = false;

  if (isTrue) {
    ({ text } = model);
    type = btnType;
  } else if (isFalse) {
    text = model.falseText;
    type = model.falseBtnType;
  }

  return btnType ? (
    <Button type={type} size={model.btnSize || model.size} className={model.className} onClick={handleChange}>
      {text || "..."}
    </Button>
  ) : (
    <Wrapper className={model.className} onClick={handleChange}>
      {text || "..."}
    </Wrapper>
  );
};

export default SelectButton;
